import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { tap, filter, first } from 'rxjs/operators';
import * as actions from '../actions';
import * as selector from '../selectors';

@Injectable({
  providedIn: 'root'
})
export class RegulatoryResolver  {
  constructor(private store: Store) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | any {
    return this.store.select(selector.getRegulatoryLoaded).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(actions.loadGetRegulatory());
        }
      }),
      filter(loaded => !!loaded),
      first()
    );
  }
}
